export const FETCH_MARK_REQUEST = 'FETCH_MARK_REQUEST';
export const FETCH_MARK_SUCCESS = 'FETCH_MARK_SUCCESS';
export const FETCH_MARK_FAILURE = 'FETCH_MARK_FAILURE';

// market type data
export const FETCH_MARK_TYPE_REQUEST = "FETCH_MARK_TYPE_REQUEST";
export const FETCH_MARK_TYPE_SUCCESS = "FETCH_MARK_TYPE_SUCCESS";
export const FETCH_MARK_TYPE_FAILURE = "FETCH_MARK_TYPE_FAILURE";
